import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import {Tooltip} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React from 'react';
import {isFunction} from '../../utilities';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },

  highlight: {
    backgroundColor: theme.palette.grey['200'],
    color: theme.palette.primary.main,
    fontWeight: '700',
  },

  cell: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },

  handle: {
    cursor: 'pointer'
  },

  attribute: {
    borderLeft: `1px solid ${theme.palette.grey['300']}`,
    flex: 1,
    justifyContent: 'flex-start'
  },

  narrow: {
    flex: '0 0 100px',
    width: 100,
  },

  button: {
    borderLeft: `1px solid ${theme.palette.grey['300']}`,
    cursor: 'pointer'
  }
}));

const Item = ({entity, attributes = [], highlight = false, controls, handleProps, attributeWidths = null}) => {
  const classes = useStyles();
  return (
    <div className={[classes.container, highlight ? classes.highlight : ''].join(' ')}>
      <div className={[classes.cell, classes.handle].join(' ')} {...handleProps}><DragIndicatorIcon/></div>
      {attributes.map((attribute, index) => (
        <div
          key={index}
          className={[classes.cell, classes.attribute].join(' ')}
          {...attributeWidths && attributeWidths[index] ? {
            style: {
              flex: `0 0 ${attributeWidths[index]}px`,
              width: `${attributeWidths[index]}px`
            }
          } : {}}>
          {attribute}
        </div>
      ))}
      {controls.filter(({shouldDisplay = () => true}) => shouldDisplay(entity)).map(
        ({title, icon, onClick = () => null}, index) => (
          <div key={index} className={[classes.cell, classes.button].join(' ')} onClick={() => onClick(entity)}>
            <Tooltip
              title={isFunction(title) ? title(entity) : title}>{isFunction(icon) ? icon(entity) : icon}</Tooltip>
          </div>
        ))}
    </div>
  );
};

export default Item;
